import { Link } from "react-scroll";

const ScrollToSectionButton = ({ children }: any) => {
  return (
    <Link
      activeClass="active"
      to="section-id"
      spy={true}
      smooth={true}
      offset={-80}
      duration={500}
    >
      <div>{children}</div>
    </Link>
  );
};

export default ScrollToSectionButton;
